import React, { useState } from "react";

const ScDicomCopyToClipboardButton = ({ viewportIndex, copyToClipboard }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    copyToClipboard(viewportIndex);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
  };

  return (<div>
    <span onClick={handleCopy}
    title="Copy viewport content to clipboard">
    <span className="svg-icon-copy-to-clipboard" ></span>
    </span> </div>
  );
};

export default ScDicomCopyToClipboardButton;
